import React from 'react';
import {
    Button, Modal, ModalBody, ModalHeader, ModalFooter
} from 'reactstrap';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { noEscChar } from '../../helpers/commonYupValidations';

function MultipleLorAddCommonModal({ handleClose,
    importLabel = "Documents Upload",
    existingFiles = [{
        requireDoc: "",
    }],
    upload,
    isModalOpen, isLoading }) {

    const initialValues = {
        requiredDocList: [
            ...existingFiles
        ],
    };

    // Validation Schema
    const validationSchema = Yup.object().shape({
        requiredDocList: Yup.array()
            .of(
                Yup.object().shape({
                    requireDoc: Yup.string().matches(noEscChar("Document Detail").regex, noEscChar("Document Detail").msg)
                        .required("Document Detail is required")
                        .min(3, "Document Detail must be at least 3 characters long"),
                })
            )
        // .min(1, "At least one doc is required"),
    });

    // On Submit
    const onSubmit = (values) => {
        upload(values);
    };

    // Add New File-Description Pair
    const addFileField = (setFieldValue, values) => {
        const newDocs = [...values.requiredDocList, { requireDoc: "" }];
        setFieldValue("requiredDocList", newDocs);
    };

    // Remove File-Description Pair
    const removeFileField = (index, setFieldValue, values) => {
        let newDoc = [];
        if (values.requiredDocList[index].id)
            newDoc = values.requiredDocList.map((doc, i) => i === index ? { ...doc, isDeleted: true } : doc);
        else
            newDoc = values.requiredDocList.filter((_, i) => i !== index);
        setFieldValue("requiredDocList", newDoc);
    };

    return (
        <Modal isOpen={isModalOpen} toggle={() => handleClose()} size='lg'>
            <ModalHeader toggle={() => handleClose()}>{importLabel}</ModalHeader>
            <ModalBody>
                <div className="mb-3">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values, setFieldValue, errors, touched, setFieldTouched, dirty }) => (
                            <Form>
                                {values.requiredDocList.map((docObj, index) => (
                                    !docObj.isDeleted && <div key={index} className="d-flex mb-2">
                                        <div style={index == 0 ? { width: "100%" } : { width: "95%" }}>
                                            <label htmlFor={`requiredDocList[${index}].requireDoc`}>
                                                Require Document
                                            </label>
                                            <Field
                                                type="text"
                                                id={`requiredDocList[${index}].requireDoc`}
                                                name={`requiredDocList[${index}].requireDoc`}
                                                placeholder="Enter Require Document"
                                                style={{ display: "block" }}
                                                className={`form-control ${touched?.requiredDocList?.length > 0 && touched.requiredDocList[index]?.requireDoc && errors?.requiredDocList?.length > 0 && errors?.requiredDocList[index]?.requireDoc ? 'is-invalid' : ''}`}
                                                disabled={docObj.id}
                                            />
                                            <ErrorMessage
                                                name={`requiredDocList[${index}].requireDoc`}
                                                component="div"
                                                style={{ color: "red" }}
                                            />
                                        </div>

                                        {!(!docObj?.id && values.requiredDocList.filter(doc => !doc.id).length === 1) && <Button
                                            type="button"
                                            color="link"
                                            className="fw-normal text-danger p-0"
                                            onClick={() => removeFileField(index, setFieldValue, values)}
                                            style={{ width: "5%" }}
                                            disabled={
                                                !docObj?.id && values.requiredDocList.filter(doc => !doc.id).length === 1
                                            }

                                        >
                                            <i className="bx bx-trash" style={{ width: '24px' }}></i>
                                        </Button>}
                                    </div>
                                ))}
                                <Button
                                    type="button"
                                    color="link mt-2"
                                    style={{ textDecoration: 'none' }}
                                    className="text-success p-0 mb-3"
                                    onClick={() => addFileField(setFieldValue, values)}

                                >
                                    <span>Add More +</span>
                                </Button>
                                <ModalFooter className='d-flex justify-content-between'>
                                    <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty || isLoading}>
                                        {'Submit'}
                                    </Button>
                                </ModalFooter>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ModalBody>
        </Modal >
    );

}

export default MultipleLorAddCommonModal;